module.exports = __webpack_public_path__ + "img/Porosity.624c5e11.png";